class BitrixApi {
    constructor (locator) {
        this._bx = locator.resolve('window').BX24;
    }

    getAuth () {
        return this._bx.getAuth();
    }
    /*
    Метод вызывается небезопасно, использовать только для получения необязательных данных
    Если нужен будет безопасный вызов лучше делать его через наше WebAPI, там реализован безопасный вызов
    */
    getCurrentUser (callbackHandler) {
        return this._bx.callMethod('user.current', {}, callbackHandler);
    }

    refreshAuth (callbackHandler) {
        return this._bx.refreshAuth(callbackHandler);
    }

    resize (w, h) {
        this._bx.resizeWindow(w, h);
    }

    fitWindow (callbackHandler) {
        this._bx.fitWindow(() => callbackHandler());
    }

    scroll (position = 0) {
        this._bx.scrollParentWindow(position);
    }

    init (responseHandler) {
        this._bx.init(responseHandler);
    }

    registerTracker () {
        const window = this._window;
        const document = this._window.document;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = this._config.analytics.yandex.url;

        const firstScriptNode = document.getElementsByTagName('script')[0];
        function bindScriptNode () {
            firstScriptNode.parentNode.insertBefore(script, firstScriptNode);
        }

        if (window.opera == '[object Opera]') {
            document.addEventListener('DOMContentLoaded', bindScriptNode, false);
        } else {
            bindScriptNode();
        }
    }
}

module.exports = BitrixApi;



// WEBPACK FOOTER //
// ./services/bitrix/api.js